/**
 * Workbench 内置事件
 *
 * @public
 */
var BuiltinUIEvent;
(function (BuiltinUIEvent) {
    BuiltinUIEvent["BeforeContextMenu"] = "$beforeContextmenuShow";
    BuiltinUIEvent["ContextMenuShowed"] = "$contextMenuShowed";
    BuiltinUIEvent["AfterContextMenuDismissed"] = "$afterContextMenuDismissed";
    BuiltinUIEvent["SurfaceSizeChanged"] = "$surfaceSizeChanged";
    BuiltinUIEvent["ToolbarUpdated"] = "$toolbarUpdated";
    BuiltinUIEvent["ToolbarShrinkUpdated"] = "$toolbareShrinkUpdated";
    BuiltinUIEvent["TitlebarMounted"] = "$titlebarMounted";
})(BuiltinUIEvent || (BuiltinUIEvent = {}));

export { BuiltinUIEvent };
//# sourceMappingURL=builtin-event.js.map
